import pathOr from 'ramda/src/pathOr';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { getFormattedServiceAttributeValue, getSuspensionTypeByCode } from './services.list.selectors.helper';
import { DiscountsMetadataMapSelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { CustomerStoreSelector, SelectedCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { getDiscountAndBriDetails } from './selected.service.details.selectors.helper';
import { CurrentCustomerSubscriberCurrencyNameSelector, IsPIIDataAccessEnabledSelector } from '../../reducers/selectors/customer.selectors';
import { IsCurrentAccountPostpaidSelector } from '../../reducers/selectors/customer.convergent.biller.selectors';
import { filterBulkOfferOptions, getOptionsByActiveBriType, isPaymentInstrumentChangeable } from '../../components/customer/dashboard/dbssDashboard/offering/offering.component.helper';
import { BILLER_RULE_INSTANCE_TYPE } from '../../customercare.constants';
import { ChangeOfferEligibilityRulesSelector, IsCoolingPeriodEnabledSelector } from '../../reducers/selectors/customer.offerings.selectors';
import { getMoreMenuItems } from '../../reducers/selectors/dashboard.selectors.helper';
import { HasSuspendResumePermissionSelector, IsServiceLifeCycleStatusUpdatableSelector } from '../../reducers/selectors/services.selectors';
import CustomerLocaleKeys from '../../locales/keys';
import { OFFERING_OPTION_STATUSES } from '../../components/shared/constants/offering.option.status.constants';
var SearchSubscriberOfferingsSelector = function SearchSubscriberOfferingsSelector(store) {
  return store.customercare.recoverableUiState.searchSubscriberOfferings;
};
export var SelectedSubscriberOfferingsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.offerings;
});
export var SearchSubscriberOfferingsDataSelector = createImmutableSelector([SearchSubscriberOfferingsSelector], function (offerings) {
  if (!offerings) {
    return EMPTY_ARRAY;
  }
  return offerings.data;
});
var getFormatedService = function getFormatedService(offer, serviceAttributes, regularExpressions) {
  var services = [];
  (offer.ServiceIdentifiers || EMPTY_ARRAY).forEach(function (service) {
    services.push(getFormattedServiceAttributeValue(service.ServiceAttributeId, service.Value, serviceAttributes, regularExpressions));
  });
  return services;
};
export var SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector = createImmutableSelector([SearchSubscriberOfferingsDataSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (offerings, serviceAttributes, regularExpressions) {
  if (!offerings) {
    return EMPTY_ARRAY;
  }
  var offersWithFormatedServices = [];
  offerings.forEach(function (offer) {
    offersWithFormatedServices.push({
      offerDetails: offer,
      formatedServices: getFormatedService(offer, serviceAttributes, regularExpressions)
    });
  });
  return offersWithFormatedServices;
});
export var SelectedSubscriberOfferingInstanceIdSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return offerings.selectedSubscriberOfferingInstanceId || '';
});
export var SelectedSubscriberOfferingWithFormattedServiceSelector = createImmutableSelector([SelectedSubscriberOfferingInstanceIdSelector, SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector], function (selectedOfferingInstanceId, offerings) {
  if (selectedOfferingInstanceId) {
    return offerings.find(function (offer) {
      return offer.offerDetails.OfferingInstanceId === selectedOfferingInstanceId;
    });
  } else {
    return offerings[0];
  }
});
export var SelectedSubscriberOfferingSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return offerings.selectedOffering && offerings.selectedOffering.SubscriberOffer || EMPTY_OBJECT;
});
export var SelectedSubscriberOfferServiceCountSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return offerings.selectedOffering ? offerings.selectedOffering.ServiceCount : '';
});
export var SelectedSubscriberServicesSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return offerings.selectedOffering ? offerings.selectedOffering.Services : EMPTY_ARRAY;
});
var getMoreMenuOptions = function getMoreMenuOptions(service, hasSuspendResumeAccess, hasUpdateServiceLifecycleStatusAccess, isPIIDataAccessEnabled) {
  var moreMenuItems = {};
  var isServiceSuspended = service.Status === NON_BULK_SERVICE_STATUSES.SUSPENDED;
  var isPendingSuspension = service.Status === NON_BULK_SERVICE_STATUSES.PENDING_SUSPENSION;
  if (isPIIDataAccessEnabled) {
    moreMenuItems[CustomerLocaleKeys.MANAGE_ADD_ONS] = {
      id: CustomerLocaleKeys.MANAGE_ADD_ONS,
      title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS),
      isLocked: isServiceSuspended,
      disabled: isServiceSuspended
    };
  }
  moreMenuItems[CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE] = {
    id: CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE,
    title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE)
  };
  if (hasSuspendResumeAccess) {
    if (service.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
      moreMenuItems[CustomerLocaleKeys.SUSPEND_SERVICE] = {
        id: CustomerLocaleKeys.SUSPEND_SERVICE,
        title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
      };
    }
    if (isServiceSuspended || isPendingSuspension) {
      moreMenuItems[CustomerLocaleKeys.RESUME_SERVICE] = {
        id: CustomerLocaleKeys.RESUME_SERVICE,
        title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
      };
    }
  }
  if (hasUpdateServiceLifecycleStatusAccess) {
    if (service.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
      moreMenuItems[CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS] = {
        id: CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS,
        title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
      };
    }
  }
  return moreMenuItems;
};
export var SubscriberServicesWithFormatedServicesSelector = createImmutableSelector([SelectedSubscriberServicesSelector, SelectedSubscriberOfferingSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression), HasSuspendResumePermissionSelector, IsServiceLifeCycleStatusUpdatableSelector, IsPIIDataAccessEnabledSelector], function (services, offering, serviceAttributes, regularExpressions, hasSuspendResumeAccess, isServiceLifeCycleStatusUpdatable, isPIIDataAccessEnabled) {
  return (services || []).map(function (service) {
    var serviceAttribute = null;
    var offeringOption = offering.Options.find(function (item) {
      if (item.ServiceIdentifierValue === service.ServiceIdentifier.Value) {
        serviceAttribute = item.ServiceAttributeValues.find(function (attribute) {
          return attribute.ServiceId && attribute.Value === service.ServiceIdentifier.Value;
        });
        return serviceAttribute;
      }
    });
    return offeringOption && {
      serviceDetails: Object.assign({}, service, {
        serviceId: serviceAttribute && serviceAttribute.ServiceId,
        suspendedDate: getFilterService()('localShortDate')(offeringOption.SuspendedDate),
        suspendType: getSuspensionTypeByCode(offeringOption.SuspendTypeCode),
        serviceFeatures: (service.ServiceFeatures || EMPTY_ARRAY).filter(function (serviceFeature) {
          return serviceFeature.Status !== OFFERING_OPTION_STATUSES.REMOVED;
        }),
        serviceIdentifierFormatted: getFormattedServiceAttributeValue(service.ServiceIdentifier.ServiceAttributeId, service.ServiceIdentifier.Value, serviceAttributes, regularExpressions)
      }),
      moreMenuOptions: getMoreMenuOptions(service, hasSuspendResumeAccess, isServiceLifeCycleStatusUpdatable, isPIIDataAccessEnabled)
    };
  }).filter(function (serviceDetails) {
    return serviceDetails;
  });
});
export var IsFetchingOfferDetailsSelector = createImmutableSelector([CustomerStoreSelector], function (customer) {
  return customer.isFetchingOfferingDetail;
});
export var SelectedOfferingAndOptionsSelector = createImmutableSelector([SelectedSubscriberOfferingSelector, SearchSubscriberOfferingsDataSelector, OfferingMetadataByIdSelector, CurrentCustomerSubscriberCurrencyNameSelector, DiscountsMetadataMapSelector, IsDbss, IsCurrentAccountPostpaidSelector, MetadataCodeTypeDictionarySelector(CODES.TransitionConfiguration), ChangeOfferEligibilityRulesSelector, IsCoolingPeriodEnabledSelector, OfferingMetadataPricingPlansSelector, IsPIIDataAccessEnabledSelector], function (subscriberOffering, searchOfferings, offeringMetadataById, currencyCode, discountsMetadataMap, isDbss, isCurrentAccountPostpaid, transitionConfiguration, changeOfferEligibilityRules, isCoolingPeriodEnabledForBU, pricingPlanThumbnails, isPIIDataAccessEnabled) {
  var metadataOffer = offeringMetadataById ? offeringMetadataById[subscriberOffering.OfferingId] : EMPTY_OBJECT;
  var allowTransitioning = pathOr(false, [Object.keys(transitionConfiguration)[0], 'AdditionalProperties', 'AllowTransitioning'], transitionConfiguration);
  var briOptions = getOptionsByActiveBriType(subscriberOffering, PRODUCT_CLASSIFICATIONS.PRODUCT);
  var hasSubscriptions = briOptions[BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION].length;
  var bulkOffer = filterBulkOfferOptions(subscriberOffering);
  var canChangePaymentInstrument = isPaymentInstrumentChangeable(subscriberOffering);
  var isInGracePeriod = subscriberOffering.Options ? subscriberOffering.Options.some(function (option) {
    return option.OffCycleDetail && option.OffCycleDetail.GracePeriodExpiryDate && option.OffCycleDetail.CurrentRenewalFailedAttempts;
  }) : false;
  var filteredOffering = (searchOfferings || []).find(function (offering) {
    return offering.OfferingInstanceId === subscriberOffering.OfferingInstanceId;
  });
  var offer = Object.keys(subscriberOffering).length ? Object.assign({}, subscriberOffering, {
    offerThumbNailUrl: metadataOffer ? metadataOffer.ThumbnailUrl : null,
    moreOptionsMenuItems: Object.keys(subscriberOffering).length ? getMoreMenuItems(hasSubscriptions, allowTransitioning, subscriberOffering, bulkOffer, changeOfferEligibilityRules, canChangePaymentInstrument, isInGracePeriod, false, pricingPlanThumbnails, false, true, isPIIDataAccessEnabled) : null,
    Options: subscriberOffering.Options.map(function (option) {
      return Object.assign({}, option, {
        discountAndBriDetails: getDiscountAndBriDetails(option, currencyCode, discountsMetadataMap)
      });
    }),
    IsCoolingOff: filteredOffering && filteredOffering.IsCoolingOff ? filteredOffering.IsCoolingOff : false
  }) : EMPTY_OBJECT;
  return offer;
});
export var OfferAdditionalPropertiesSelector = createImmutableSelector([SelectedSubscriberOfferingSelector], function (selectedOffering) {
  return (selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.OrderedOfferingAdditionalProperties) || [];
});
export var IsFetchingOfferingsSelector = createImmutableSelector([SearchSubscriberOfferingsSelector], function (offerings) {
  return offerings.isLoading;
});
export var SubsriberOfferingsPaginationDataSelector = createImmutableSelector([SearchSubscriberOfferingsSelector, PageSizePreferenceSelector], function (offerings, defaultPageSize) {
  if (!offerings.paginationData.pageSize) {
    return Object.assign({}, offerings.paginationData, {
      pageSize: defaultPageSize
    });
  }
  return offerings.paginationData;
});
export var SubsriberOfferingsFilterDataSelector = createImmutableSelector([SearchSubscriberOfferingsSelector], function (offerings) {
  return offerings.filterData;
});
export var SelectedOfferingInventoryItemsSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return pathOr([], ['selectedOffering', 'InventoryItems'], offerings).map(function (inventoryItem) {
    return Object.assign({}, inventoryItem, {
      serviceFeatures: (inventoryItem.ServiceFeatures || EMPTY_ARRAY).filter(function (serviceFeature) {
        return serviceFeature.Status !== OFFERING_OPTION_STATUSES.REMOVED;
      })
    });
  });
});
export var SelectedOfferingInventoryItemsCountSelector = createImmutableSelector([SelectedSubscriberOfferingsSelector], function (offerings) {
  return pathOr(null, ['selectedOffering', 'InventoryItemCount'], offerings);
});